import { connect } from 'react-redux'

import {
  getProducts,
  searchForProfiles,
  setData,
  profileIdsSearch,
  setFilterStatus,
  setSortField,
  setSortOrder,
} from 'reduxpath/ducks/Product/List'

import {
  getPortfolios,
} from 'reduxpath/ducks/Product/Detail'

import SortHeader from './units'

const mapStateToProps = state => ({
  param: {
    searchProfileField: state.ProductList.searchProfileField,
    selectedCountry: state.Reference.selectedCountry,
    selectedService: state.Reference.selectedService,
    sortField: state.ProductList.sortField,
    sortOrder: state.ProductList.sortOrder,
    filterStatus: state.ProductList.filterStatus,
  },
})

const mapDispatchToProps = dispatch => ({
  handleSort(param, currentPage = 1) {
    return (sortField, sortOrder) => () => {
      const {
        searchProfileField,
        selectedCountry,
        selectedService,
        filterStatus,
      } = param
      dispatch(setFilterStatus(filterStatus))
      dispatch(setSortField(sortField))
      dispatch(setSortOrder(sortOrder))
      if (searchProfileField.length > 0) {
        const regexEmail = /^([a-z0-9_.-]+)([+0-9]+)*@([\da-z.-]+)\.([a-z.]{2,6})$/
        const data = {
          limit: 99999,
          skip: 0,
          where: {
            or: [
              { name: { like: `%${searchProfileField}%` } },
              { profileId: { like: `%${searchProfileField}%` } },
            ],
          },
        }
        if (regexEmail.test(searchProfileField)) {
          data.where = { email: searchProfileField }
        }
        dispatch(searchForProfiles(data, (profiles) => {
          const profileIdsResult = profiles.rows.map(value => value.id)
          const qs = {
            sort: {
              isEligible: 'DESC',
              [sortField]: sortOrder,
            },
            limit: 10,
            skip: (currentPage - 1) * 10,
            where: {
              isPublished: true,
              isEligible: false,
            },
          }
          if (selectedService) {
            qs.where.service = selectedService
          }
          if (selectedCountry) {
            qs.where.country = selectedCountry
          }
          if (profileIdsResult) {
            qs.where.profile = profileIdsResult
          }
          dispatch(profileIdsSearch(profileIdsResult))
          dispatch(
            getProducts(qs, (res) => {
              const products = res
              let counter = 0
              products.rows.forEach((product) => {
                const p = product
                dispatch(
                  getPortfolios(p.id, {
                    sort: 'status ASC',
                    limit: 1000000,
                    skip: 0,
                  }, (portfolios) => {
                    counter += 1
                    p.portfolios = portfolios
                    if (counter === products.rows.length) {
                      dispatch(setData(products))
                    }
                  }),
                )
              })
            }),
          )
        }))
      } else {
        const qs = {
          sort: {
            isEligible: 'DESC',
            [sortField]: sortOrder,
          },
          limit: 10,
          skip: (currentPage - 1) * 10,
          where: {
            isPublished: true,
            isEligible: false,
          },
        }
        if (selectedService) {
          qs.where.service = selectedService
        }
        if (selectedCountry) {
          qs.where.country = selectedCountry
        }
        if (filterStatus >= 0) {
          qs.where.status = filterStatus
        }
        dispatch(
          getProducts(qs, (res) => {
            const products = res
            let counter = 0
            products.rows.forEach((product) => {
              const p = product
              dispatch(
                getPortfolios(p.id, {
                  sort: 'status ASC',
                  limit: 1000000,
                  skip: 0,
                }, (portfolios) => {
                  counter += 1
                  p.portfolios = portfolios
                  if (counter === products.rows.length) {
                    dispatch(setData(products))
                  }
                }),
              )
            })
          }),
        )
      }
    }
  },
})

const mergeProps = (stateProps, dispatchProps, parentProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...parentProps,
  handleSort: dispatchProps.handleSort(stateProps.param),
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(SortHeader)
